import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderUnitsStore implements SaveStateHolder {
  @observable
  readonly unitIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly levelId: number, unitIds: number[]) {
    makeObservable(this);
    this.unitIds = unitIds;
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.unitIds, index1, index2);
  }

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    const reordered = this.unitIds.slice();
    this.save = contentLoaders.x3level.orderChildren(this.levelId, reordered);
  };
}
